
import SignIn from './views/account/signin.vue'
import Sales_Tasks from './views/Sales_Tasks.vue'
import Sales_Task_Day from './views/Sales_Task_Day.vue'
import History from './views/History.vue'

let routes = [

    {
        path: '/account/signin',
        name: 'signin',
        component: SignIn,
        meta: { requiresLogin: false },
    },
    {
        path: '/sales_tasks',
        name: 'sales_tasks',
        component: Sales_Tasks,
        props: false,
        meta: { requiresLogin: true },
    },
    {
        path: '/sales_task_day',
        name: 'sales_task_day',
        component: Sales_Task_Day,
        props: true,
        meta: { requiresLogin: true },
    },
    {
        path: '/history',
        name: 'history',
        component: History,
        props: false,
        meta: { requiresLogin: true },
    },


];

export default routes;
